import intl from 'react-intl-universal';
import _ from 'lodash';

import httpService from '../_utils/http-service';
import { getHttpConfig, getAuthHttpConfig } from '../_utils/auth-utils';
import { traceEvent } from "../_utils/analytics-utils";

export const fetchCuisines = (callback) => {

    return function (dispatch, getState) {

        // if user has set  the current location we fetch local cuisines
        let url = '/cuisines'
        const searchSettings = getState().searchSettings;
        if (searchSettings.currentLocation !== null) {
            const { latitude, longitude } = searchSettings.currentLocation;
            url = `/cuisines/local?latitude=${latitude}&longitude=${longitude}`;
        }

        let httpConfig = getHttpConfig();
        let storage = getState().storage;
        if (storage.authToken !== undefined) {

            httpConfig = getAuthHttpConfig(storage);
        }

        httpService.get(url, httpConfig)
            .then((res) => {
                if (res.data.statusCode === 200) {
                    let cuisines = res.data.data;
                    _.map(cuisines, cuisine => cuisine.checked = false);

                    callback({ success: true, cuisines });
                } else {
                    callback({ success: false });
                    traceEvent("error", "fetchCuisines");
                }
            }).catch(err => {
                traceEvent("error", "fetchCuisines");
                callback({ success: false, message: intl.get('general.serverError') });
            })
    }
}